import settings from "../utils/settings";

/**
 * {
      "item_ref": "0004",
      "event_code": "REDEEM",
      "item_type": "discount",
      "discount_amount": -3,
      "redeem": {
        "type": "reward",
        "amount": -30
      }
    },
 */
class PointasCash {
  constructor(point) {
    this.point = point;
  }

  get discount() {
    return getDiscountfromPoint(this.point);
  }

  getPayloadData() {
    const discount = getDiscountfromPoint(this.point);
    return {
      item_ref: "",
      event_code: "REDEEM",
      item_type: "discount",
      discount_amount: discount,
      redeem: {
        type: "reward",
        amount: -this.point,
      },
    };
  }
}

const getDiscountfromPoint = (point) => {
  const { redeemCash, redeemPoint } = settings();

  const discount = -Math.floor((point * redeemCash) / redeemPoint);
  return discount;
};

export default PointasCash;
export { getDiscountfromPoint };
